module.exports = __webpack_public_path__ + "img/Monk.61bb68f8.png";